import React from 'react';
import { motion } from 'framer-motion';
import * as variants from '../utils/animations';

const AnimatedDiv = (props) => {
  return (
    <motion.div {...props} {...variants[props.animation]}>
      {props.children}
    </motion.div>
  )
}

export default AnimatedDiv;